export default __webpack_public_path__ + "static/media/rewards_bg_m.fa2262fd.png";